(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smb-availability"] && !Shopify.designMode) return;
  try {
    (function () {
    function go(e) {
      var el = e.target.closest && e.target.closest('.smb-av__ship[data-smb-href]');
      if (!el) return;
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = el.getAttribute('data-smb-href');
    }
    document.addEventListener('click', go, true);
    document.addEventListener('keydown', go, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
